import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage-deep warm-glow text-center text-white" aria-label="Limited time offer" data-id="element-267" data-mp="369pga49jt16e">
      <div className="harvest-bar h-2 w-full" aria-hidden="true" data-id="element-268" data-mp="31jhcm36k04r0" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-269" data-mp="31h4plblxv473">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-goldLight" data-id="element-270" data-mp="3g72iu5yq6k35">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="3b8iszuh0go5i" /> Launch pricing ends in
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-272" data-mp="3p8a67szpe0ig" />
        <p className="mt-7 font-bold text-mutedDark" data-id="element-273" data-mp="3l6owuhmdo4d0">After that the price increases and never drops again.</p>

        <div className="panel-dark mx-auto mt-6 max-w-xl rounded-lg border border-lineDark p-4 text-sm" data-id="element-274" data-mp="1uu0uhg816876">
          <p className="font-bold" data-id="element-275" data-mp="1qu8tppovp6cd">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-danger" data-id="element-276" data-mp="1qva4ru5w9su3" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/40" data-id="element-277" data-mp="2xtsr7msoy469">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-gold" data-id="element-278" data-mp="32rc4ajdnkawm" />
          </div>
          <p className="mt-1 text-right text-xs text-mutedDark" data-id="element-279" data-mp="3gipkbnccqqmw">66% of spots taken</p>
        </div>
      </div>
      <div className="harvest-bar h-2 w-full" aria-hidden="true" data-id="element-280" data-mp="3li25m3nkrpnd" />
    </section>;
}